module.exports = __webpack_public_path__ + "static/media/img_sendero.6c90c3b3.jpg";